<template>
  <div class="p-stepper mt-1" @click.stop>
    <button
      v-if="!isFreeProduct"
      class="p-stepper-button"
      @click="decrement"
      :disabled="decrementDisabled"
    >
      <v-icon x-small color="var(--light-color)">mdi-minus</v-icon>
    </button>

    <div class="p-stepper-number">
      <i-numeric-field
        :preventEmpty="preventEmptyQuantity"
        :disabled="disabled"
        hide-details
        :min="min"
        :max="max"
        v-model="inputValue"
        @input="setQuantity"
      ></i-numeric-field>
    </div>
    <button
      v-if="!isFreeProduct"
      class="p-stepper-button"
      @click="increment"
      :disabled="incrementDisabled"
    >
      <v-icon x-small color="var(--light-color)">mdi-plus</v-icon>
    </button>
  </div>
</template>

<script>
import iNumericField from '@/components/NumericField'

export default {
  components: {
    iNumericField
  },

  emits: ['change'],

  props: {
    cartSKU: {
      type: Boolean,
      default: false
    },
    cartSKUMobile: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 999
    },
    preventEmptyQuantity: {
      type: Boolean,
      default: false
    },
    isFreeProduct: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    inputValue: null,
    debounceQuantityChange: null
  }),

  computed: {
    decrementDisabled() {
      return this.value <= this.minimumQuantity || this.isFreeProduct
    },

    incrementDisabled() {
      return this.value >= this.max || this.isFreeProduct
    },

    minimumQuantity() {
      return this.preventEmptyQuantity ? Math.max(1, this.min) : this.min
    }
  },

  methods: {
    setQuantity(value) {
      if (value === '') this.inputValue = 0
      else this.inputValue = parseInt(value, 0)

      clearTimeout(this.debounceQuantityChange)
      this.debounceQuantityChange = setTimeout(async () => {
        this.$emit('change', this.inputValue)
      }, 750)
    },

    increment() {
      this.$emit('change', this.value + 1)
    },

    decrement() {
      this.$emit('change', Math.max(this.minimumQuantity, this.value - 1))
    }
  },
  mounted() {
    this.inputValue = this.value
  },

  watch: {
    value() {
      this.inputValue = this.value
    }
  }
}
</script>

<style lang="scss">
.p-stepper {
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    caret-color: white;
    color: white;
    text-align: center;
    &::selection {
      background: #fff;
      color: $secondary-color;
    }
  }
}
</style>

<style lang="scss" scoped>
$size: 32px;

.p-stepper {
  display: flex;
  height: $size;
  min-width: 110px;
  color: white;
  border-radius: 30px;
  overflow: hidden;
  &-button {
    background-color: $secondary-color;
    color: white;
    height: $size;
    flex: 1;
    outline: 0;
    border: none;
    &[disabled] {
      opacity: 0.8;
    }
    &-text {
      letter-spacing: 2px;
    }
  }
  &-number {
    display: inline-block;
    background-color: $primary-color;
    text-align: center;
    font-size: 14px;
    flex: 1;
    line-height: $size;
    font-weight: bold;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
}
</style>
